module.exports = __webpack_public_path__ + "img/Whats Next_v2.06fc0a71.jpg";